/**
 * Liest die Fehlermeldung aus einer geparsten Backend-Fehlerantwort. Zertifikats-/
 * Signaturfehler liefert das Backend verschachtelt als { error: { message } }. Schlägt dagegen
 * schon die ASP.NET-Modellvalidierung fehl (z. B. [Range] auf PdfRectDTO: "Seite muss mindestens
 * 1 sein."), kommt ValidationProblemDetails - dort steht in title nur der generische Satz
 * "One or more validation errors occurred.", die eigentliche Meldung in errors.
 */
export function extractBackendErrorMessage(
  parsed: any,
  fallback: string,
): string {
  return (
    parsed?.error?.message ??
    parsed?.message ??
    firstValidationError(parsed?.errors) ??
    parsed?.title ??
    fallback
  );
}

function firstValidationError(errors: unknown): string | undefined {
  if (!errors || typeof errors !== 'object') return undefined;
  for (const messages of Object.values(errors as Record<string, unknown>)) {
    if (Array.isArray(messages) && typeof messages[0] === 'string') {
      return messages[0];
    }
  }
  return undefined;
}
